import React from 'react';

import styled from 'styled-components';
import media from 'styles/media';
import colors from 'styles/colors';
import text from 'styles/text';

import CloudPartner from 'images/ChromeBook/CloudPartner.webp'
import ChromeRecommended from 'images/ChromeBook/ChromeRecommended.webp'
import EdPartner from 'images/ChromeBook/EdPartner.webp'

const ChromeLogoBanner = () => {
  return (
    <Wrapper>
      <LogosContainer>
        <Logo alt="chrome recommended" src={ChromeRecommended}/>
        <Logo alt="ed partner" src={EdPartner}/>
        <Logo alt="cloud partner" src={CloudPartner}/>
      </LogosContainer>
    </Wrapper>
  )
}

export default ChromeLogoBanner

const Logo = styled.img`
  margin: 0.694vw;
  height: 8.542vw;

  ${media.fullWidth} {
    margin: 10px;
    height: 123px;
  }
  
  ${media.tablet} {
    margin: 0.781vw;
    height: 9.609vw;
    width: 25.879vw;
  }
  
  ${media.mobile} {
    margin: 1.869vw;
    height: 22.991vw;
  }
`
const LogosContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: auto;
  height: auto;
  gap: 2.569vw;

  ${media.fullWidth} {
    gap: 37px;
  }
  
  ${media.tablet} {
    gap: 2.148vw;
  }
  
  ${media.mobile} {
    flex-direction: column;
    gap: 2.336vw;
  }
`
const Wrapper = styled.div`
  padding: 0 10.139vw 5.556vw 10.139vw;

  ${media.fullWidth} {
    padding: 0 146px 80px 146px;
  }
  
  ${media.tablet} {
    padding: 0 5.859vw 3.906vw 5.859vw;
  }
  
  ${media.mobile} {
    padding: 0 15.234vw 9.346vw 15.234vw;
  }
`